import { useEffect, useState } from 'react';
import { getConfigKeyContent, invalidateConfigKeysCache } from '@/services/config/config-keys-store';

export const CONFIG_KEY_CO_CAU_GIAI_DOAN = 'config_setting_co_cau_giai_doan';

/** Checkbox Cấu hình: Áp dụng Cơ cấu giai đoạn (mặc định tắt). */
export function useCoCauGiaiDoanConfigEnabled() {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    void getConfigKeyContent(CONFIG_KEY_CO_CAU_GIAI_DOAN, 'false')
      .then((value) => {
        if (!cancelled) {
          setEnabled(value === 'true');
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setEnabled(false);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    enabled: enabled ?? false,
    loading,
  };
}

export function invalidateCoCauGiaiDoanConfigCache() {
  invalidateConfigKeysCache();
}
